import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { formatUrl } from '@ifeng/three_terminal/es/base/publicMethod';
import Ad from '@ifeng/ui_pc_ad';
import { NormalCaption, SlidesTabs, Copyright } from '@ifeng/three_terminal/es/mobile/index';
import { cookie, ajax } from '@ifeng/three_terminal/es/base/base/index';
import Content from './content';
import NewsList from './newsList';
import Chip from 'Chip';
import ImageNav from './imageNav';
import CheckPrice from './checkPrice';
import ChipEdit from 'ChipEdit';
import transform from 'chipDataTransform';
import styles from './index.css';
import BMap from 'BMap';
import { checkSearchPath } from '../../utils/checkSearchPath';

const DefaultCode = '310000';
const cookieName = 'auto_iploc';
const cookieCity = 'auto_city';
const cookiePy = 'auto_py';
const cookieFl = 'auto_fl';

class Layout extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };
    constructor(props, content) {
        super(props, content);

        const { jdtRecommend, jdtAdRecommend } = this.props.content;

        this.state = {
            code: '',
            name: '',
            pinyin: '',
            firstLetter: '',
            news: props.content.newsstream,
            pnews: props.content.preloadNewsstream,
            xuanran: null,
            jdtimg: jdtRecommend.concat(jdtAdRecommend),
            xuanran1: null,
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (props.item !== state.item) {
            return {
                item: props.item,
            };
        }

        return null;
    }
    async componentDidMount() {
        // 上报首屏时间
        if (window && window.BJ_REPORT) window.BJ_REPORT.firstScreen();

        if (checkSearchPath(this.props.content.columnId).length === 1) {
            let getCityData = null;
            if (window.location.search.includes('city')) {
                let code = window.location.search.substr(1);

                try {
                    code = /city=(\d+)/gi.exec(code)[1];
                } catch (e) {
                    window.location.href = '/';
                }

                let getCitycodeData = await this.getCityCode(code);

                let cdata = getCitycodeData.data[0].match.map(value => {
                    return {
                        code: value.match_citycode,
                        name: value.match_name,
                        pinyin: value.match_pinyin,
                        firstLetter: value.match_pinyin.substring(0, 1).toLocaleUpperCase(),
                    };
                });

                getCityData = cdata[0];
            } else {
                getCityData = await this.getCitycodeByBaidu(cookieName);
            }

            this.setState(
                {
                    ...getCityData,
                },
                () => {
                    this.getJdtNews();
                    this.getlocnews();
                },
            );
        }
    }
    getCitycodeByBaidu(cname) {
        return new Promise((resolve, reject) => {
            let locdata = { code: DefaultCode, name: '上海市', pinyin: 'shanghai', firstLetter: 'S' };

            if (cookie.get(cname) == null || cookie.get(cname) === '') {
                if (navigator.geolocation) {
                    const geolocation = new BMap.Geolocation();

                    // eslint-disable-next-line func-names
                    geolocation.getCurrentPosition(
                        // eslint-disable-next-line func-names
                        function(position) {
                            if (!this.getStatus()) {
                                const lon = position.point.lng;
                                const lat = position.point.lat;
                                const myGeo = new BMap.Geocoder();

                                myGeo.getLocation(new BMap.Point(lon, lat), async result => {
                                    if (result) {
                                        const city = result.addressComponents.city;

                                        try {
                                            const codeData = await ajax('//s.auto.ifeng.com/district/code', {
                                                data: { name: city },
                                            });

                                            locdata = codeData.data;
                                        } catch (e) {
                                            console.log(e);
                                        }

                                        const cookieval = locdata.code.replace(/[^0-9]/gi, '');
                                        const cookieLoc = locdata.name;
                                        const cookiepinyin = locdata.pinyin;
                                        const cookieFirst = locdata.firstLetter;

                                        cookie.set(cookieName, cookieval);
                                        cookie.set(cookieCity, cookieLoc);
                                        cookie.set(cookiePy, cookiepinyin);
                                        cookie.set(cookieFl, cookieFirst);
                                        resolve(locdata);
                                    } else {
                                        resolve(locdata);
                                    }
                                });
                            }
                        },
                        () => {
                            resolve(locdata);
                        },
                        {
                            enableHighAccuracy: true,
                        },
                    );
                }
            } else {
                locdata = {
                    code: cookie.get(cookieName),
                    name: cookie.get(cookieCity),
                    pinyin: cookie.get(cookiePy),
                    firstLetter: cookie.get(cookieFl),
                };

                resolve(locdata);
            }
        });
    }
    getCityCode(code) {
        let auto_iploc = code;

        if (code == null || code === '') {
            auto_iploc = '110000';
        }

        const url = '//api.auto.ifeng.com/cms/api/cityInfo_new';

        const parm = {
            match: 1,
            citycode: auto_iploc,
        };
        let data = ajax(url, {
            data: parm,
            timeout:3000
        });

        return data;
    }
    titleString(channel) {
        if (channel.length <= 1) {
            const fc = channel[0];

            return [{ title: fc.title, url: formatUrl(fc.domain) }];
        } else {
            return [{ title: '资讯', url: formatUrl('iauto.ifeng.com') }];
        }
    }
    formatNav(topNav = []) {
        const nav = [];

        for (const item of topNav) {
            const newItem = { ...item };

            if (newItem.mUrl) {
                newItem.url = newItem.mUrl;
            }

            nav.push(newItem);
        }

        let loc = { title: this.state.name, url: `${this.state.pinyin}/` };

        if (this.state.pinyin !== '') {
            nav.splice(2, 0, loc);
        }

        return nav;
    }

    async getlocnews() {
        let newsDf = [];
        let cl = this.props.content.mainRecommend;
        let newslist = this.props.content.newsstream.map(value => {
            return {
                id: value.id,
                title: value.title,
                url: value.url,
                thumbnails: value.thumbnails,
                newsTime: value.newsTime,
                source: value.source,
                type: value.type,
                searchPath: value.searchPath,
            };
        });
        let pnewslist = this.props.content.preloadNewsstream.map(value => {
            return {
                id: value.id,
                title: value.title,
                url: value.url,
                thumbnails: value.thumbnails,
                newsTime: value.newsTime,
                source: value.source,
                type: value.type,
                searchPath: value.searchPath,
            };
        });
        let getdata = {}
        try{
            getdata = await ajax('//api.auto.ifeng.com/cms/api/revision/wapNews', {
                data: { city: this.state.pinyin },
                timeout: 3000
            });
        }catch(e){
            getdata = {
                data:{
                    guide: [],
                    reduce: [],
                    tuangou: []
                }
            }
        }

        if (typeof getdata.data !== 'object') {
            //window.location.href = '/';
            getdata = {
                data:{
                    guide: [],
                    reduce: [],
                    tuangou: []
                }
            }
        }
        const locdata = getdata.data;

        const loc_position = {
            tuangou: [7, 15, 25, 30, 35],
            reduce: [11, 12, 21, 23, 31, 41, 42],
            guide: [17, 19],
        };

        for (let item in locdata) {
            locdata[item] = locdata[item].map((value, key) => {
                return {
                    id: `${item}_${key}`,
                    position: loc_position[item][key],
                    title: typeof value.title === 'undefined' ? value.grouponname : value.title,
                    url: value.url,
                    thumbnails: { image: [{ url: typeof value.thumb === 'undefined' ? value.imgurl : value.thumb }] },
                    newsTime: '',
                    source: '',
                    type: '',
                    searchPath: ' ',
                };
            });
        }

        for (let item in locdata) {
            locdata[item].forEach((value, index) => {
                if (value.title !== '' && typeof value.title !== 'undefined') {
                    if (value.thumbnails.image[0].url === '') delete value.thumbnails;
                    newsDf.push(value);
                }
            });
        }
        cl.forEach((value, index) => {
            if (value.newsTime !== 'undefined') {
                let nowTime = new Date().getTime();
                let oldTime = new Date(value.endTime).getTime();

                if (nowTime > oldTime) {
                    cl.splice(index, 1);
                }
            }
        });

        newsDf.push(...cl);
        newsDf.sort(this.compare('position'));

        newsDf.forEach(v => {
            if (v.position < newslist.length) {
                newslist.splice(v.position - 1, 0, v);
            } else {
                let p = v.position - newslist.length - 1;

                pnewslist.splice(p, 0, v);
            }
        });

        this.setState({
            news: newslist,
            pnews: pnewslist,
            xuanran: true,
        });
    }
    compare(property) {
        return (a, b) => {
            let value1 = a[property];

            let value2 = b[property];

            return value1 - value2;
        };
    }
    // 获取地方站焦点图
    async getJdtNews() {
        try {
            const jdtData = await ajax('//api.auto.ifeng.com/cms/api/block/city_block_v2', {
                data: {
                    city: this.state.pinyin,
                    pos: 'iautoIndexBanner',
                },
                timeout:3000
            });
            this.props.content.mainData[0].data = this.state.jdtimg;
            if (jdtData.data.title !== '' && typeof jdtData.data.title !== 'undefined') {
                console.log(3,this.props.content.mainData[0].data.splice(2, 0, jdtData.data))
                this.props.content.mainData[0].data.splice(2, 0, jdtData.data);
            }
            this.props.content.mainData[0].componentOptions.length = this.props.content.mainData[0].data.length;
        } catch (e) {
            console.log("jdt",e);
        }
    }
    render() {
        const { content } = this.props;

        const contentData = {
            mainData: content.mainData,
            noAd: content.noAd,
        };
        let newsStreamData = {
            newsstream: [...this.state.news],
            preloadNewsstream: content.preloadNewsstream,
            commonIdArray: content.commonIdArray,
            newsStream: content.newsStream,
            columnId: content.columnId,
            isEnd: content.isEnd,
            isScrollLoadingData: true,
            ad: content.newsStream1Ad,
            searchPathMap: content.searchPathMap,
        };

        if (this.state.xuanran === null && checkSearchPath(this.props.content.columnId).length === 1) return null;

        return (
            <Fragment>
                {/* 通栏广告 */}
                {content.passAd ? <Ad content={content.passAd} /> : null}
                {content.nav && !content.isApp ? (
                    <div className={styles.caption}>
                        <Chip
                            id={checkSearchPath(content.columnId).length > 1 ? 170039 : 20002}
                            type="struct"
                            title="右上角导航"
                            groupName="右上角导航栏"
                            content={content.nav.nav}>
                            <NormalCaption title={this.titleString(content.channel)} />
                        </Chip>
                    </div>
                ) : null}
                {content.topNav && content.topNav.length > 0 ? (
                    <Chip
                        id={checkSearchPath(content.columnId).length > 1 ? 65006 : 80038}
                        type="struct"
                        title="导航"
                        groupName="导航栏"
                        content={this.formatNav(content.topNav)}>
                        <SlidesTabs currentPath={content.columnId} />
                    </Chip>
                ) : null}
                <Chip
                    id="225033"
                    type="recommend"
                    title="焦点图信息推荐位(图一，图二)"
                    groupName="焦点图"
                    content={contentData}>
                    <Content loc={this.state.pinyin} />
                </Chip>
                <Chip
                    id="255041"
                    type="recommend"
                    title="焦点图广告信息推荐位(图三，注：因有其它图片插入有时会显示在图四位置)"
                    groupName="焦点图"
                    content={contentData}>
                    <div />
                </Chip>
                {content.main_0_ad ? <Ad content={content.main_0_ad} /> : null}
                {content.imgNav && content.imgNav.length > 0 ? (
                    <Chip id="80041" type="struct" title="图片导航" groupName="图片导航栏" content={content.imgNav}>
                        <ImageNav url={this.state.code} />
                    </Chip>
                ) : null}
                <NewsList content={newsStreamData} />
                <Chip id="90008" type="recommend" title="信息流推荐位" groupName="信息流" content={contentData}>
                    <div />
                </Chip>
                {!content.isApp ? <Copyright /> : null}
                <ChipEdit transform={transform} />
                <CheckPrice content={this.state.pinyin} />
                {/* 底部广告 */}
                {content.footerAd ? <Ad content={content.footerAd} /> : null}
            </Fragment>
        );
    }
}

export { Layout };
export default Layout;
